export function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}



// WEBPACK FOOTER //
// ./node_modules/moment/src/lib/moment/creation-data.js